import { Col, ControlLabel, FormGroup, OverlayTrigger, Popover } from "react-bootstrap";
import YesNoUnknown from "../yes-no-unknown";

interface IProps {
    isWorkedUp: boolean,
    onChange?: (name: string, value: boolean) => void,
}

const IsWorkedUp = (props: IProps) => (
    <FormGroup>
        <Col xs={12} lg={2} componentClass={ControlLabel}>Is Worked Up:</Col>
        <Col xs={12} lg={4}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <YesNoUnknown name='isWorkedUp' yes={props.isWorkedUp} no={!props.isWorkedUp} onChange={props.onChange} />
                <div style={{ paddingLeft: 20 }}>
                    <OverlayTrigger trigger={['hover', 'click']} placement='bottom' overlay={<Popover>Donor workup shall include a CT scan except when the pair's "exchange power score" is zero.
                        In this case an ultrasound or MRA/MRI can be used in place of a CT scan so long as the donor CT scan can be within 2 weeks of match acceptance.</Popover>}>
                        <span className='glyphicon glyphicon-info-sign'></span>
                    </OverlayTrigger>
                </div>
            </div>
        </Col>
    </FormGroup>
)

export default IsWorkedUp;